// extracted by mini-css-extract-plugin
export default {"radio":"CanvasTypeChoices-module__radio__zKvn5"};